import request from '@/utils/request'

export function login(data,log) {
  return request({
    url: '/login',
    method: 'post',
    data,
    log,
  })
}

export function goHaveTo(log) {
    return request({
        url: '/haveTo',
        method: 'post',
        log,
    })
}

export function getUserInfo(log) {
  return request({
    url: '/userInfo',
    method: 'get',
    log,
  })
}

export function getMenu(usid,log) {
  return request({
    url: `/sys/menu/listMenuByUserId`,
    method: 'get',
    log,
  })
}

export function checkLogin(usId, params) {
  return request({
    url: `/sys/menu/listMenuByUserId`,
    method: 'get',
    params
  })
}
export function logout(log) {
  return request({
    url: '/logout',
    method: 'get',
    log,
  })
}
//企业列表查询
export function searchEnterprise(data,params){
  return request({
    url:'/extSys/enterprise/list',
    data,
    method:'post',
    params
  })
}
//省市联动
export function areaConfig(data) {
  return request({
    url: '/areaConfig/area/list',
    method: 'post',
    data
  })
}
//注册
export function registerUser(data){
  return request({
    url: '/extSys/user/registerUser',
    method: 'post',
    data
  })
}
//修改密码
export function updatePassword(data,log){
  return request({
    url: '/newUpdatePassword',
    method: 'put',
    data,
    log
  })
}


//密码找回
export function findPassword(data){
  return request({
    url: '/extSys/user/sendUrlByEmail',
    method: 'post',
    data
  })
}

//重置密码
export function setPassword(url,data){
  return request({
    url: '/extSys/user/updateUserPsw?code=' + url,
    method: 'post',
    data
  })
}

//忘记用户名
export function loginNameLost(email, log) {
  return request({
    url: `/loginnamelost/${email}`,
    method: 'get',
    log
  })
}

//忘记密码
export function passwordLost(params, log) {
  return request({
    url: `/passwordlost`,
    method: 'get',
    params,
    log
  })
}

export function searchSetUserByUserId(log) {
  return request({
    url: `/camds/setUserManage/searchSetUserByUserId`,
    method: 'get',
    log
  })
}

export function goSave(data, log) {
  return request({
    url: `/camds/setUserManage/goSave`,
    method: 'post',
    data,
    log
  })
}

export function getClientManagerPage(data, log) {
  return request({
    url: `/camds/setUserManage/getClientManagerPage`,
    method: 'post',
    data,
    log
  })
}

export function queryLoginNameInit(data, log) {
  return request({
    url: `/queryLoginNameInit`,
    method: 'post',
    data,
    log
  })
}

export function changePassword(params, log) {
  return request({
    url: `/changePassword`,
    method: 'get',
    params,
    log
  })
}

export function passwordUpdata(params, log) {
  return request({
    url: `/passwordUpdata`,
    method: 'get',
    params,
    log
  })
}

export function getAnnouncement(log) {
  return request({
    url: `/getAnnouncement`,
    method: 'get',
    log
  })
}

export function saveAnnouncement(data, log) {
  return request({
    url: `/saveAnnouncement`,
    method: 'post',
    data,
    log
  })
}

export function updateNextShow(userId, nextShow, log,loadding) {
  return request({
    url: `/sys/user/updateNextShow/${userId}/${nextShow}`,
    method: 'post',
    params: { loadding },
    log
  })
}

// 绑定scip账号
export function scipUserinfo(data, log) {
  return request({
    url: `/scip/scipUserinfo`,
    method: 'post',
    data,
    log
  })
}

export function putScipUserinfo(data, log) {
  return request({
    url: `/scip/scipUserinfo`,
    method: 'put',
    data,
    log
  })
}

//查询scip账号
export function getScipUserInfo( log) {
  return request({
    url: `/scip/scipUserinfo/getScipUserInfo`,
    method: 'post',
    log
  })
}



